import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, FormGroup, Form } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import InputFile from '../../../components/cms/form/inputFile';
import PreviewImage from '../../../components/previewImage';
import MlFields from '../../../components/cms/form/mlFields';
import {Link} from "react-router-dom";
import CompanyService from "../../../services/company.service";

const twoCols = { xs: 12, md: 6 };

const Item = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  tab,
  isSubmitting,
  isSubmittingRedirect,
  imageSrc,
  searchCompany,
  onChangeCompanyInput,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-font pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              <Row>
                <Col md={9}>
                  <InputGroup
                    name="title"
                    label={t('Title')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.title}
                    icon="fa fa-star"
                  />
                  <InputGroup
                    type="textarea"
                    name="description"
                    label={t('Description')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.description}
                    rows={10}
                  />
                  <InputGroup
                    type="textarea"
                    name="chars"
                    label={t('Chars')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.chars}
                    rows={10}
                  />
                  <InputGroup
                    name="priority"
                    label={t('Priority')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.priority}
                    icon="fa fa-star"
                  />
                  <InputGroup
                    id="company_id"
                    label={t('Companies')}
                    name="companies"
                    placeholder={t('Companies')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.companies}
                    icon="fa fa-group"
                    type="async"
                    loadOptions={searchCompany}
                    onInputChange={onChangeCompanyInput}
                    isMulti={true}
                  />
                  <FormGroup row className="my-0">
                    <Col {...twoCols}>

                    </Col>
                    <Col {...twoCols}>

                    </Col>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <div className="">
                    <InputFile id="image">
                      <PreviewImage src={imageSrc} className="" alt="img" height="120" />
                    </InputFile>
                    <InputGroup
                      name="status"
                      label={t('Status')}
                      onChange={onChange}
                      errors={errors}
                      type="checkbox"
                      value={1}
                      checked={formData.status}
                    />
                    <InputGroup
                      name="is_default"
                      label={t('Is default')}
                      onChange={onChange}
                      errors={errors}
                      type="checkbox"
                      value={1}
                      checked={formData.is_default}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>
              <div>
                <strong>Description example (must be an array of objects {'[{},{},{}]'}):<br /></strong>
                [<br />
                {'{'}<br />
                {tab} "fName": "FSecureSans-Bold",<br />
                {tab} "fFamily": "FSecure Sans Bold",<br />
                {tab}  "fStyle": "Regular",<br />
                {tab}  "ascent": 67.999267578125<br />
                {'}'}<br />
                ]
                <br />
                <strong>Chars example (must be an array []):<br /></strong>
                [<br />
                {'{'}<br />
                  "ch": "1",
                  "size": 155,
                  "style": "Regular",
                  "w": 50,
                  "data": ...
                  <br />{'}'},<br />
                {'{'}<br />
                  "ch": "2",
                  "size": 155,
                  "style": "Regular",
                  "w": 50,
                  "data": ...
                  <br />{'}'}<br />
                ...
                <br />
                ]
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Item.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/views/fonts/item/Item.jsx